module.exports = __webpack_public_path__ + "static/media/laravel.14fd8fbf.svg";